import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'reactstrap';

import 'assets/scss/subscriptionModal.css';
import SubscriptionModal from './subscriptionModal';

const ConfirmCancelSubscription = ({
  isVisible,
  toggleModal,
  password,
  handleChange,
  cancelSubscription,
}) => (
  <SubscriptionModal
    isVisible={isVisible}
    toggleModal={toggleModal}
    handleCancel={toggleModal}
    handleConfirm={cancelSubscription}
    confirmText="Cancel Subscription"
  >
    <div className="modal-body p-5">
      <h1 className="modal-subtitle text-bold text-left">
        Confirm Cancelation
      </h1>
      <p className="modal-description text-left mt-3">
        You will need to confirm your password before proceeding with
        cancelation of your subscription. Cancellation will take effect at the
        end of the month.
      </p>
      <Input
        className="password-input"
        type="password"
        name="password"
        value={password}
        onChange={handleChange}
      />
    </div>
  </SubscriptionModal>
);

ConfirmCancelSubscription.defaultProps = {
  isVisible: false,
  password: '',
};

ConfirmCancelSubscription.propTypes = {
  isVisible: PropTypes.bool,
  toggleModal: PropTypes.func.isRequired,
  password: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  cancelSubscription: PropTypes.func.isRequired,
};

export default ConfirmCancelSubscription;



// WEBPACK FOOTER //
// ./src/components/Modal/subscription/confirmCancelSubscription.js